import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useListTranslation = () => {
  const { t } = useTranslation()

  const translateEntity = (entityKey: string) => {
    const entityTranslationKey = `ColumnSettingsDialog.Entities.${entityKey}`
    return t(entityTranslationKey)
  }

  const translateColumn = (columnKey: string) => {
    const columnTranslationArray = [`${columnKey}`, `entities.${columnKey}`, `entities.${columnKey.toLowerCase()}`]
    return t(columnTranslationArray)
  }

  const tl = (columnName: string): [entityName: string, columnName: string] => {
    const [entityName] = columnName.split('.')

    return [translateEntity(entityName), translateColumn(columnName)]
  }

  return useMemo(
    () => ({
      translateEntity,
      translateColumn,
      tl
    }),
    [translateEntity, translateColumn]
  )
}
